import {baseApi} from '../../state/rest'

export const AIDAApi = {
  ...baseApi,
  async getAIDAResponse({prompt, chatId}: {prompt: string; chatId: string}) {
    try {
      const req = await this.doRequest({
        path: '/v1/aida',
        payload: {data: {message: prompt, chatId}}
      })
      const resp = await req.post()

      return resp.data
    } catch (error) {
      throw error // Re-throw so caller can handle it
    }
  },
  async clearAIDAConversation(chatId: string) {
    try {
      const req = await this.doRequest({
        path: '/v1/aida/clear',
        payload: {data: {chatId}}
      })
      await req.post()
    } catch (error) {
      throw error
    }
  }
}
